import React from "react";
import '../../../App.scss';
import backgroundImage from "../../../assets/images/main_background.png";
import {withRouter} from "react-router-dom";
import SingleBoard from '../../pageComponents/WinnersTable/SingleBoard'
import Grid from "@material-ui/core/Grid";
import circleWood from '../../../assets/images/circle_wood_empty.png'
import squareWood from '../../../assets/images/empty_wood.png'
import woodenBackground from '../../../assets/images/img_woodi.png'
import Star from '../../../assets/images/state_star.png'
import TopUsersHeader from "../../pageComponents/WinnersTable/Header";
import UserRank from "../../pageComponents/WinnersTable/UserRank";
import Toolbar from "../../Toolbar";
import axios from "axios";
import {leaderBoardDynamic} from "../../../Utility/Url";
import {connect} from "react-redux";
import {data} from "../../../Store/Actions/DataAction";
import {free} from "../../../Store/Actions/FreeAction";
import PicoLoader from "../../pageComponents/Common/PicoLoader";
class MainLeague extends React.Component{
    constructor(props) {
        super(props)
        this.state= {
            appHasLoaded: false,
            datas:null,
            style: {
                completed: 5,
                root: {
                    flexGrow: 1,
                    backgroundImage: "url(" + backgroundImage + ")",
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    width: '100%',
                    backgroundColor: "rgba(255, 190, 51, 1)",
                    height: '100%',
                    overflow: 'hidden',
                    backgroundBlendMode:'soft-light',
                    flex:1,
                    minHeight:'0'
                },
            }
        }
    }
    fetchData= async()=>{
        await axios.get(`users/data`)
            .then(res => {
                const {data}=res
                this.props.data(data)
            }).catch(error=>{
                console.log(error.toString())
                }
            )
    }
    fetchBoeardData= async(id)=>{
        await axios.get(`${leaderBoardDynamic}/${id}`)
            .then(res => {
                const {data}=res
                this.setState({
                    datas:data
                })
            }).catch(error=>{
                console.log(error.toString())
                }
            )
    }
    async componentDidMount() {
        const{id}=this.props.match.params
        this.props.toggleBottomNavbar(false)
        this.fetchData()
        this.fetchBoeardData(id)
    }

    render(){
        let rank={
            avatar: "http://picopool.ir/_data/Boy/6.png",
            gift: " ",
            id:"" ,
            name: "",
            point: "",
            pos: "",
            self: "",
            try: "",
        }
        let items=[
            {
                squareWood:squareWood,
                rank:'1',
                rankColor:'yellow',
                woodenBackground:woodenBackground,
                name:'iman',
                score:'4',
                prize:'جایزه',
                price:'20',
                avatarHolder:circleWood,
                layerColor:'rgba(255,255,26,0.5)',
                boardType:'single',
                starIcon:Star
            }
        ]
        let UserHeader= {
            headerText:'لیگ کلی',
            users:[
                {
                    name:'iman',
                    score:'امتیاز : 268',
                    award:'60 دلار'
                },
                {
                    name:'iman',
                    score:'امتیاز : 268',
                    award:'60 دلار'
                },
                {
                    name:'iman',
                    score:'امتیاز : 268',
                    award:'60 دلار'
                },
            ]
        }
        if (this.state.datas) {
            const {datas} = this.state
            let sort = datas.list.sort(function (a, b) {
                return (a.pos) - (b.pos);
            });
            let sortClone = [...sort]
            let headers = sortClone.splice(0, 3)
            let soretdItems = sort.splice(3)
            rank={
                avatar:datas.self.avatar!=undefined?datas.self.avatar:'',
                gift: datas.self.gift,
                id: datas.self.id,
                name: datas.self.name,
                point: datas.self.point,
                pos: datas.self.pos,
                self: datas.self.self,
                try: datas.self.try,
            }
            UserHeader = {
                headerText: datas.leagueInfo.name,
                users: headers.map(data => {
                    return {
                        name: data.name,
                        id: data.id,
                        score: `امتیاز : ${data.point}`,
                        award: data.gift,
                        pos:data.pos,
                        self:data.self,
                        avatar:data.avatar
                    }
                })
            }
            items=soretdItems.map(data => {
                return{
                    name: data.name,
                    id: data.id,
                    score: data.point,
                    // award: data.gift,
                    pos:data.pos,
                    self:data.self,
                    try:data.try,
                    squareWood:squareWood,
                    avatar:data.avatar,
                    rankColor:'yellow',
                    rank:data.pos,
                    woodenBackground:woodenBackground,
                    prize:'جایزه',
                    price: data.gift,
                    avatarHolder:circleWood,
                    layerColor:(data.pos)<=10?'rgba(255,255,26,0.5)':'',
                    boardType:'double',
                    starIcon:Star
                }
            })
        }
            return(
            <Grid direction={"column"} item container style={this.state.style.root}>
                {
                    this.state.datas &&
                    <Grid item sm={12} xs={12} direction={"column"} justify={'center'} container
                          style={{flex:'1',minHeight:'0'}}
                    >
                        <Grid item container>
                            <Toolbar type='sideToolbar'/>
                        </Grid>
                        <Grid item justify={"center"} container>
                            <Grid item sm={11} xs={11} justify={'center'} container style={{marginTop:'0px'}}>
                                <UserRank data={rank}/>
                            </Grid>
                        </Grid>
                        <Grid item container xs={12} justify={"center"} sm={12} className='scrollBar'
                              style={{flex:'1',minHeight:'0',overflow:'auto'}}>
                            <Grid item sm={12}  xs={12} justify={'center'} container>
                                <Grid item sm={11} xs={11} justify={'center'} style={{marginTop:'50px'}} container>
                                    <TopUsersHeader userHeader={UserHeader}/>
                                </Grid>
                                {items.map(data=>{
                                    return  <Grid item sm={11} xs={11} style={{margin:'5px'}} justify={'center'} container

                                    >
                                        <SingleBoard data={data}/>
                                    </Grid>}
                                )
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                }
                {
                    !this.state.datas &&
                    <Grid m={2} xs={2} container alignItems={"center"} direction={"row-reverse"} justify={"center"}
                          style={{position:'relative',
                              top:'50%',left:'50%',transform:'translate(-50%,-50%)'}}
                    >
                        <Grid item container justify={"center"} style={{position:'absolute',
                        }}>
                            <PicoLoader/>
                        </Grid>
                    </Grid>
                }
            </Grid>
        )
    }
}
const Main=withRouter (MainLeague)
const mapStateToProps=state=>({
    UserData:state.UserData,
})
export default connect(mapStateToProps,{data})(Main)